import { createAction } from 'redux-actions';
import { SET_PAGE } from '../actionTypes';

const setPage = createAction<string>(SET_PAGE);

export {
  setPage
};
